const GRID_VIEWS = {
  detailed: {
    'grid-desktop': 'grid--3-col-desktop',
    'grid-mobile': 'grid--1-col-tablet-down',
    heading: 'h2',
  },
  simple: {
    'grid-desktop': 'grid--4-col-desktop',
    'grid-mobile': 'grid--2-col-tablet-down',
    heading: 'h3',
  },
};

class GridToggle extends HTMLElement {
  constructor() {
    super();
    this.grid = document.querySelector('.product-grid-container');
    this.wrapper = document.querySelector('#product-grid');
    this.init();
  }

  init() {
    if (!this.grid || !this.wrapper) return;
    const stored = localStorage.getItem('grid-view') ?? this.dataset.defaultView ?? 'simple';
    this.transitionTo(stored, 0);
    this.addEventListener('click', this.select.bind(this));

    document.addEventListener('grid-toggle:reveal', () => {
      this.wrapper = document.querySelector('#product-grid');
      this.grid = document.querySelector('.product-grid-container');
      const view = localStorage.getItem('grid-view') ?? this.dataset.defaultView ?? 'simple';
      this.transitionTo(view, 0);
    });
  }

  select(event) {
    if (this._transitioning) return;
    const option = event.target.closest('.grid-toggle__option');
    if (!option) return;
    const view = option.dataset.view;
    if (!view || view === this.grid.dataset.view) return;
    localStorage.setItem('grid-view', view);
    this.transitionTo(view);
  }

  transitionTo(view, delay = 300) {
    this._transitioning = true;
    this.wrapper.classList.add('is-fading');

    const apply = () => {
      this.grid.dataset.view = view;
      this.applyView(view);
      this.updateActiveState(view);

      const animatedItems = [...this.wrapper.querySelectorAll('.grid__item.animate--slide-in')];
      animatedItems.forEach((item) => item.classList.remove('animate--slide-in'));

      void this.wrapper.offsetHeight;

      animatedItems.forEach((item) => item.classList.add('animate--slide-in'));
      this.wrapper.classList.remove('is-fading');
      this._transitioning = false;
    };

    if (delay === 0) {
      requestAnimationFrame(apply);
    } else {
      setTimeout(apply, delay);
    }
  }

  updateActiveState(view) {
    this.querySelectorAll('.grid-toggle__option').forEach((option) => {
      option.classList.toggle('is-active', option.dataset.view === view);
    });
  }

  applyView(view) {
    this.applyClasses(view);
    this.applyDescriptions(view);
    this.applyHeadings(view);
  }

  applyClasses(view) {
    const current = GRID_VIEWS[view];
    const other = GRID_VIEWS[view === 'simple' ? 'detailed' : 'simple'];
    this.wrapper.classList.remove(other['grid-desktop'], other['grid-mobile']);
    this.wrapper.classList.add(current['grid-desktop'], current['grid-mobile']);
  }

  applyHeadings(view) {
    const current = GRID_VIEWS[view].heading;
    const other = GRID_VIEWS[view === 'simple' ? 'detailed' : 'simple'].heading;
    this.wrapper.querySelectorAll('.card__heading').forEach((heading) => {
      heading.classList.replace(other, current);
    });
  }

  applyDescriptions(view) {
    const selector = view === 'simple' ? '.card__short-description' : '.card__long-description';
    this.wrapper.querySelectorAll('template.card__descriptions').forEach((template) => {
      const target = template.nextElementSibling;
      const node = template.content.querySelector(selector)?.cloneNode(true);
      if (target && node) target.replaceChildren(node);
    });
  }
}

customElements.define('grid-toggle', GridToggle);
